export enum HourlyBonusState {
    DEFAULT = 'DEFAULT',
    DAILY = 'DAILY',
    PIGGY = 'PIGGY'
}